import { render, staticRenderFns } from "./CallDetails.vue?vue&type=template&id=0d5e584d&scoped=true"
import script from "./CallDetails.vue?vue&type=script&lang=js"
export * from "./CallDetails.vue?vue&type=script&lang=js"
import style0 from "./CallDetails.vue?vue&type=style&index=0&id=0d5e584d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5e584d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d5e584d')) {
      api.createRecord('0d5e584d', component.options)
    } else {
      api.reload('0d5e584d', component.options)
    }
    module.hot.accept("./CallDetails.vue?vue&type=template&id=0d5e584d&scoped=true", function () {
      api.rerender('0d5e584d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/conversations/call-dialog/CallDetails.vue"
export default component.exports